// src/pages/shop/ShopPerishable.jsx
// Список товаров, у которых есть партия со сроком ≤48ч (модуль «Скоропорт»).
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { products as productsApi } from '../../api';
import Icon from '../../components/Icon';

export default function ShopPerishable() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    productsApi.expiring()
      .then(r => setItems(r.items || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  const hoursLabel = (h) => {
    if (h <= 1) return t('perishable.lessHour', 'меньше часа');
    if (h < 24) return t('perishable.hours', '{{h}} ч', { h });
    const d = Math.floor(h / 24);
    return t('perishable.daysH', '~{{d}} дн', { d });
  };

  return (
    <div className="page">
      <div className="page-header">
        <button className="back-btn" onClick={() => navigate(-1)}><Icon name="chevronLeft" size={18} /></button>
        <h1 className="page-title">{t('perishable.title', 'Скоропорт')}</h1>
      </div>

      {loading ? (
        <div style={{ padding: 40, textAlign: 'center' }}><div className="spinner" /></div>
      ) : items.length === 0 ? (
        <div style={{ padding: '30px 20px', textAlign: 'center', color: 'var(--fg-muted)' }}>
          <Icon name="alert" size={32} />
          <p style={{ marginTop: 10, fontSize: 14 }}>{t('perishable.empty', 'Пока нет товаров с истекающим сроком.')}</p>
        </div>
      ) : (
        <div style={{ padding: '0 20px' }}>
          <div style={{ background: 'var(--warning-soft, #fdf3e4)', color: '#8a5510', borderRadius: 'var(--r-md)', padding: '12px 14px', fontSize: 13, lineHeight: 1.5, marginBottom: 14 }}>
            {t('perishable.warnHint', 'Среди этих товаров могут быть единицы, у которых срок годности заканчивается в ближайшие 24–48 часов. Проверьте на полке.')}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            {items.map(p => (
              <div key={p.productId}
                style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', background: 'var(--bg-elevated)', border: `1px solid ${p.level === 'red' ? 'var(--danger)' : 'var(--warning, #d98324)'}`, borderRadius: 'var(--r-sm)' }}>
                {p.photo
                  ? <img src={p.photo} alt="" style={{ width: 40, height: 40, borderRadius: 6, objectFit: 'cover', flexShrink: 0 }} />
                  : <span style={{ width: 40, height: 40, borderRadius: 6, background: 'var(--bg-subtle)', flexShrink: 0 }} />}
                <span style={{ flex: 1, minWidth: 0 }}>
                  <span style={{ display: 'block', fontSize: 14, fontWeight: 700, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{p.name}</span>
                  <span style={{ display: 'block', fontSize: 12, color: p.level === 'red' ? 'var(--danger)' : 'var(--warning, #d98324)', fontWeight: 600 }}>
                    {t('perishable.leftLabel', 'осталось')} {hoursLabel(p.hoursLeft)}
                  </span>
                </span>
                <span style={{ width: 10, height: 10, borderRadius: '50%', background: p.level === 'red' ? 'var(--danger)' : 'var(--warning, #d98324)', flexShrink: 0 }} />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
